import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { Accordion, Grid, Header, Icon, Image, Label, Message, Segment } from "semantic-ui-react";
import styles from "../../../../Assessment/AssessmentInfoSlideControls/LearnMoreTemplate.module.css"

const cdnRoute = process.env.REACT_APP_CDN_ROUTE + "/family/";
const iconRoute = process.env.REACT_APP_CDN_ROUTE + "/icons/";

const CaringForYourselfLearnMore: React.FC = () => {
  const [activeAccordionIndexes] = useState([0, 1]);

  const renderAccordionTips = () => {
    return (
      <>       
        <Grid stackable className={styles.learnMoreFullDiv} >
          <Grid.Row columns='equal' stretched className={styles.highlightsItemRow} >
            <Grid.Column stretched className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >  
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}Meditate3.png`} className={`${styles.highlightsItemHeaderImgEnlargeIcon} ${styles.highlightsIconEnlarge}`} />
                  <p className={styles.highlightsItemHeaderTitle} >SELF-CARE STRATEGIES</p> 
                  <Header.Subheader>
                    <p className={styles.learnMoreAccordionText} >
                      <b>Develop specific strategies for taking care of your own health and well-being while caring 
                        for someone.</b> <br/> Eating well, getting enough sleep, engaging in some type of light exercise, 
                        meditation, and journaling can all help to alleviate caregiver stress. </p> 
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
            <Grid.Column stretched container className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >  
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}ShieldFromNegativity2.png`} className={`${styles.highlightsItemHeaderImgEnlargeIcon} ${styles.highlightsIconEnlargeXL}`} />
                  <p className={styles.highlightsItemHeaderTitle} >RECOGNIZE & PREVENT</p>
                  <Header.Subheader> 
                    <p className={styles.learnMoreAccordionText} >
                      <b>Learn how to recognize and prevent caregiver burnout.</b> <br/> Keep an eye out for symptoms like: 
                        trouble sleeping, fatigue, rapid weight gain/loss, moodiness, persistent sadness, and lack of 
                        interest in previously enjoyed activities. All of these can be signs that you're heading for 
                        burnout.</p>
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns='equal' stretched className={styles.highlightsItemRow} >
            <Grid.Column stretched className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >  
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}SupportGroup.png`} className={`${styles.highlightsItemHeaderImgEnlargeIcon} `} />
                  <p className={styles.highlightsItemHeaderTitle} >SUPPORT GROUP</p> 
                  <Header.Subheader>
                    <p className={styles.learnMoreAccordionText} >
                      <b>Consider attending or starting a caregiver support group.</b> <br/> Having a support system to lean 
                        on can be a lifesaver during these stressful times. Check with your local community or church to 
                        see if there are any support groups in your area. Online support groups can also be a great way 
                        to talk to others.</p> 
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
            <Grid.Column stretched container className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >  
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}MedicareRemote2.png`} className={styles.highlightsItemHeaderImgIcon} />
                  <p className={styles.highlightsItemHeaderTitle} >RESPITE CARE</p>
                  <Header.Subheader> 
                    <p className={styles.learnMoreAccordionText} >
                      <b>Learn about respite care services in your locality.</b> <br/> These short-term services can give 
                        caregivers a break to refresh themselves, while providing safe care for their loved one.</p>
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </>
    );
  };


  const accordions = [
    { key: 'tips',
      index: 0,
      title: { 
        icon: <Icon name='dropdown' className={styles.learnMoreAccordionLabelTitleIcon} />, 
        content: <Label className={styles.learnMoreAccordionLabelTitle} > Tips on Preventing Caregiver Burnout </Label> },
      content: { 
        content: (<Message className={styles.learnMoreAccordionMessageBox} content={renderAccordionTips()}/>)
      }
    }
  ];

  
  return (
    <>
      <Segment className={styles.learnMoreBackgroundImg} style = {{ backgroundImage: `url(${cdnRoute}CaringForYourselfLearnMore2.jpg)`, }}>
        <div className={styles.learnMoreModalContent}>
          
          <div className={styles.learnMoreAccordionFullDivGrid} >
            <div className={styles.learnMoreAccordionFullDiv} >
              <Accordion panels={accordions} className={styles.learnMoreModalAccordionGroup} defaultActiveIndex={activeAccordionIndexes} exclusive={false} />
            </div> 
          </div>  

        </div>
      </Segment>      
    </>
  );  
};

export default observer(CaringForYourselfLearnMore);
